<div class="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 mt-6 gap-6">
    <div *ngFor="let item of aboutData" class="text-center px-6 mt-6">
        <div class="size-20 bg-red-500/5 text-red-500 rounded-xl text-3xl flex align-middle justify-center items-center shadow-sm dark:shadow-gray-800 mx-auto">
            <i [attr.data-feather]="item.icon" class="size-[30px]"></i>
        </div>

        <div class="content mt-7">
            <a [routerLink]="item.link" class="h5 text-lg font-medium hover:text-red-500">{{item.title}}</a>
            <p class="text-slate-400 mt-3">{{item.desc}}</p>
            
            <div class="mt-5">
                <a [routerLink]="item.link" class="text-red-500">Read More <i class="mdi mdi-chevron-right"></i></a>
            </div>
        </div>
    </div>
</div>
